import React from 'react'
import { useState } from 'react'
import { pdf } from '@react-pdf/renderer'
import type { DocumentProps } from '@react-pdf/renderer'
import { registerFonts } from './theme'
import { MetricsReport } from './documents/MetricsReport'
import type { MetricsReportData } from './documents/MetricsReport'

function promptToSlug(prompt: string): string {
  return prompt
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .slice(0, 48)
    .replace(/-+$/, '')
}

export function useMetricsPdf() {
  const [isGenerating, setIsGenerating] = useState(false)

  async function downloadPdf(result: MetricsReportData, prompt: string, chartImageUrl?: string): Promise<void> {
    setIsGenerating(true)
    try {
      registerFonts()
      const element = React.createElement(MetricsReport, {
        result: { ...result, chartImageUrl },
        prompt,
        generatedAt: new Date(),
      })
      const blob = await pdf(element as React.ReactElement<DocumentProps>).toBlob()
      const url = URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = `metrics-${promptToSlug(prompt) || 'report'}.pdf`
      anchor.click()
      URL.revokeObjectURL(url)
    } finally {
      setIsGenerating(false)
    }
  }

  return { downloadPdf, isGenerating }
}
